// Action Option Keys:
export const CUSTOM_LIST_TOKEN_OPTION_KEY = 'custom_list_token';
export const CUSTOM_LIST_VERSION_OPTION_KEY = 'custom_list_major_version';
export const CUSTOM_LIST_COLUMNS_OPTION_KEY = 'version_columns';
